

const apiUrl = process.env.REACT_APP_API_URL

export default class MessageService {


    static getDiscussionMessages(username:string) {
      
        return fetch(`${apiUrl}/api/message/${username}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
               
            }
        })
        .then(response => response.json())
        .catch(error => this.handleError(error));
        
  
    }

    static getMessagesList() {
      
        return fetch(`${apiUrl}/api/message/`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            
            }
        })
        .then(response => response.json())
        .catch(error => this.handleError(error));
        
  
    }


    static async newMessage(message: any){
        return fetch(`${apiUrl}/api/message/`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
               
            },
            body: JSON.stringify(message),
        })
        .then(response => response.json())
        .catch(error => this.handleError(error));
    }
   


    static handleError(error: Error): void {
      console.error(error);
    }
  }